export default {"src":"/_next/static/media/laboratory-blood-tests.ac796c81.svg","height":546,"width":379,"blurWidth":0,"blurHeight":0};